import InfoPage from '@modules/professional/page/InfoPage';
import { loader } from '@modules/professional/api/info-page-loader.server';
import type { APHandle } from '~/modules/root';

export const handle: APHandle = {
    showBannerAndLogoMobile: true,
    hideContactArchiPro: true,
};

export { loader };
export default InfoPage;
